<template>
    <v-col v-bind="columnProps">
        <v-card class="fill-height">
            <v-toolbar color="grey-lighten-4" density="compact" flat>
                <template #title>{{ displayTitle }}</template>
            </v-toolbar>

            <v-divider />

            <v-card-text class="d-flex flex-column align-center justify-center dashboard-widget-loader">
                <v-progress-circular color="primary" indeterminate size="34" width="3" />
                <div class="mt-4 text-medium-emphasis">Ładowanie...</div>
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script setup lang="ts">
/*
Organization / ordering applied:
1. Imports
2. Props / Emits
3. Constants
4. Stores & top-level services
5. Reactive state (refs/reactive)
6. Validation rules & setup
7. Computed
8. Handlers / methods
9. Helpers / lifecycle
*/

// 1. Imports
import { computed } from 'vue'

import type { DashboardWidget } from '@/stores/dashboard'
import {
    DASHBOARD_WIDGET_COLUMNS,
    type DashboardWidgetSize,
    getDashboardWidgetDisplayTitle
} from '@/views/Dashboard/dashboardUtils'

// 2. Props / Emits
const props = withDefaults(
    defineProps<{
        widget: DashboardWidget
        size?: DashboardWidgetSize
    }>(),
    { size: 'small' }
)

// 7. Computed
const columnProps = computed(() => (props.size === 'large' ? DASHBOARD_WIDGET_COLUMNS.LARGE : DASHBOARD_WIDGET_COLUMNS.SMALL))
const displayTitle = computed(() => getDashboardWidgetDisplayTitle(props.widget))
</script>

<style scoped>
.dashboard-widget-loader {
    min-height: 180px;
}
</style>
